import type { QueryObject } from '@/shared/lib/serializeQuery';
import type { SearchCriteriaParams } from '@/shared/model';
import { toId } from './values';

export function departureCity(query: QueryObject): Pick<SearchCriteriaParams, 'departureCity'> | null {
  const id = toId(query.fromCity);

  return id === null ? null : { departureCity: { id, name: '' } };
}
